import React, {Component} from 'react';
import {observer} from "mobx-react";
import HTML from "../../Helpers/HTML";
import AttachmentSpoiler from "./AttachmentSpoiler";
import LazyBlock from "../../Helpers/LazyBlock";

class Embed extends Component {
  componentDidMount() {

  }
/*  renderPlaceHolder() {
    if(this.props.data.oembed.provider_name == "Soundcloud") {
      return (
        <div style={{ maxWidth:'100%', width:400 }} className="center pr">
          twitter!
        </div>
      )
    }
    if(this.props.data.oembed.provider_name == "Twitter") {
      return (
        <div style={{ maxWidth:'100%', width:400 }} className="center pr">
          twitter!
        </div>
      )
    }
    return (
      <div style={{ maxWidth:'100%', width:400 }} className="center pr">
        <div style={{paddingBottom: '66%'}} className="bg-w2"></div>
      </div>
    );
  }*/
  renderVideoWrapper(inner) {
    return (
      <LazyBlock>
        <div style={{ maxWidth:'100%', width:400 }} className="center pr">
          <div style={{paddingBottom: '66%'}}
               className={`oembedHere pr content_type_${this.props.data.oembed.type} provider_${this.props.data.oembed.provider_name}`}>
            <div className="pa pa-tl w100 h100">
              <div className="pr w100 h100">
                {inner}
              </div>
            </div>
          </div>
        </div>
      </LazyBlock>
    )
  }
  renderTwitterWrapper(inner) {
    return (
      <div style={{height: 300, width: 400, maxWidth:' 100%'}} className="ofa center">
        <LazyBlock>
          <div ref={()=>{ this.loadScripts(); }}>
            {inner}
          </div>
        </LazyBlock>
      </div>
    )
  }
  renderSoundcloudWrapper(inner)
  {
    return (
      <div style={{height: 160, width: 400, maxWidth:' 100%'}} className="ofa center">
        <LazyBlock>
          <div ref={()=>{ this.loadScripts(); }}>
            {inner}
          </div>
        </LazyBlock>
      </div>
    );
  }
  renderUniversalWrapper(inner) {
    if(this.props.data.oembed.type == "video") {
      return this.renderVideoWrapper(inner);
    }
    if(this.props.data.oembed.provider_name == "Twitter") {
      return this.renderTwitterWrapper(inner);
    }
    if(this.props.data.oembed.provider_name == "SoundCloud") {
      return this.renderSoundcloudWrapper(inner);
    }
    return inner;
  }
  loadScripts() {
    if (this.props.data.oembed) {
      if (this.props.data.oembed.add_js) {
        const scriptId = `script_${this.props.data.oembed.provider_name}`;
        if (!document.getElementById(scriptId)) {
          const s = document.createElement('script');
          s.type = 'text/javascript';
          s.async = true;
          s.src = this.props.data.oembed.add_js;
          s.id = scriptId;
          document.getElementsByTagName("head")[0].appendChild(s);
        } else {
          if (typeof window.twttr !== "undefined") {
            window.twttr.widgets.load();
          }
        }
      }
    }
  }
  render() {
    if(!this.props.data || !this.props.data.oembed) {
      return null;
    }
    if(this.props.data.spoiler && !this.props.data.show_spoiler) {
      return (
        <AttachmentSpoiler data={this.props.data} />
      )
    }
    return this.renderUniversalWrapper(<HTML>{this.props.data.oembed.html}</HTML>);

    /*
    if(this.props.data.oembed.type == "video") {
      return this.renderVideoWrapper(<HTML>{this.props.data.oembed.html}</HTML>);
    } else {
      return (
        <LazyBlock placeHolder={()=>{ return this.renderPlaceHolder(); }}>
          <div ref={()=>{ this.loadScripts(); }} style={{width: 400, maxWidth: '100%'}} className="center pr">
            <HTML>{this.props.data.oembed.html}</HTML>
          </div>
        </LazyBlock>
      )
    }
    */

    return (
      <div>

      </div>
    )
  }
}

export default observer(Embed);